var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2 text-position",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"site-name text-uppercase gray--text text--lighten-5"},[_c('span',[_vm._v(_vm._s(_vm.theme.siteName))])]),_c('div',{staticClass:"gray--text text-capitalize site-description mt-2"},[_c('span',[_vm._v(_vm._s(_vm.theme.siteDescription))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }